import styled from "styled-components";

const BackTitle = styled.p`
  color: ${props => props.theme.colors.brand.blueOmint};
	text-decoration: underline;
	font-size: 16px;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 8px;
  cursor: pointer;
  margin: ${({ m }) => m || '0 0 24px 0'};

	&:hover {
		text-decoration: underline;
	}

	span {
		font-size: 18px;
	}

  @media (min-width: ${props => props.theme.sizes.breakPoints.mobile}) {
    display: none; 
  }
`

const Header = styled.div`
	display: flex;
	align-items: flex-start;
	flex-direction: column;
`

const DefaultTitle = styled.h1`
	font-size: 28px;
	font-weight: 600;
	margin: 0;
	color: ${props => props.theme.colors.text.titleText};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 24px;
	}
`

export {
  BackTitle,
  Header,
  DefaultTitle
}